const isOnMac = () => window.navigator.platform.includes('Mac');

const isMobileSafari = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream && /Safari/.test(userAgent) && !/CriOS/.test(userAgent));
};

export { isOnMac, isMobileSafari };
